import { render, staticRenderFns } from "./ViewpointMappingFactor.vue?vue&type=template&id=c98c9eaa&scoped=true&"
import script from "./ViewpointMappingFactor.vue?vue&type=script&lang=ts&"
export * from "./ViewpointMappingFactor.vue?vue&type=script&lang=ts&"
import style0 from "./ViewpointMappingFactor.vue?vue&type=style&index=0&id=c98c9eaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98c9eaa",
  null
  
)

export default component.exports